import { FC } from 'react';
import { useRecordContext } from 'react-admin';

import { GetB2bCampaignOneResponse } from '@Common/types/bo/b2b/campaigns';

import { B2bSavingsFundsRequestActionsInternal } from '@sh4res/bo-common/components/B2bSavingsFundRequests/B2bSavingsFundRequestsAction';

type AdditionalSfr = NonNullable<
  GetB2bCampaignOneResponse['additional_savings_funds_requests']
>[number];

export const B2bCampaignFundRequestActions: FC = () => {
  const record = useRecordContext<GetB2bCampaignOneResponse>();

  return (
    <>
      <B2bSavingsFundsRequestActionsInternal<GetB2bCampaignOneResponse>
        record={record}
        fundRequestIdField="savings_funds_request_id"
        isMarkedAsPaidField="savings_funds_request_is_marked_as_paid"
        isMarkedAsCompletedField="savings_funds_request_is_marked_as_completed"
        isMarkedAsCancelledField="savings_funds_request_is_marked_as_cancelled"
        totalNetAmountField="savings_funds_request_total_net_amount"
      />
      {record?.additional_savings_funds_requests?.map((sfr) => (
        <B2bSavingsFundsRequestActionsInternal<AdditionalSfr>
          key={sfr.id}
          record={sfr}
          fundRequestIdField="id"
          isMarkedAsPaidField="is_marked_as_paid"
          isMarkedAsCompletedField="is_marked_as_completed"
          isMarkedAsCancelledField="is_marked_as_cancelled"
          totalNetAmountField="total_net_amount"
        />
      ))}
    </>
  );
};
